exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".headerMain{margin:5.6vh 4.91vw 0 5vw;min-height:8.34vh}.headerMain .date-section{margin-top:0;margin-left:84.2vw}.headerMain p{text-align:center;font-size:20px}.headerMain .account-icon{float:left;height:6.4vh}.headerMain .myAccount{color:#f1f1f1;font-weight:800;line-height:1;position:absolute;padding-left:1.15vw;font-size:2.03vw;top:6.25vh;left:4vw;font-family:Open Sans Bold}.headerMain .myAccount-grey{color:#9ea6a8}.headerMain .user-name{padding-left:1.15vw;font-weight:700;font-style:normal;font-size:1.5vw}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/appheader/appheader.scss
// module id = 24
// module chunks = 0